import { useMutation } from "@apollo/client";
import CREATE_ASSET from "queries/createAsset.gql";
import { useCallback, useEffect, useState } from "react";
import { findLocalStorageItem } from "utils/LocalStorage";
import { logGqlErrorToSentry } from "utils/sentry";
import dataUrlToFile from "../utils/imageConverter";

const useCreateAssetFromStorage = () => {
  const [isResolved, setResolved] = useState(false);
  const [localItem, setLocalItem] = useState("");
  const [assetId, setAssetId] = useState("");
  const [error, setError] = useState();
  const [mutate, { loading }] = useMutation(CREATE_ASSET, { errorPolicy: "all" });

  const createAsset = (key, nestedKey) => {
    if (nestedKey) {
      findLocalStorageItem(key, nestedKey).then((file) => {
        if (file) {
          setResolved(true);
          setLocalItem(file);
        } else {
          setError("could not find local item");
        }
      });
    }
  };

  const handleUpload = useCallback(async () => {
    try {
      const file = await dataUrlToFile(localItem, "campaignBanner.jpg");
      const result = await mutate({ variables: { upload: file } });

      if (result.errors?.length) {
        logGqlErrorToSentry(result.errors[0], "Onboarding: Could not create asset", {
          storage_data: JSON.parse(localStorage.getItem("onBoarding")) ?? [],
        });
        setError(result.errors[0]);
        return;
      }

      setAssetId(result.data?.createAsset?.asset?.id);
    } catch (err) {
      console.error("Error uploading asset:", err);
      setError(err);
    }
  }, [localItem, mutate]);

  useEffect(() => {
    if (isResolved && localItem) {
      handleUpload();
    }
  }, [isResolved, localItem, handleUpload]);

  return {
    createAssetFromStorage: (key, nestedKey) => {
      if (!loading) {
        createAsset(key, nestedKey);
      }
    },
    assetId,
    loading,
    error,
  };
};

export default useCreateAssetFromStorage;
